import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import DiligenceRangeFields from './DiligenceRangeFields'

export const DiligenceRangeEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props} />}>
      <Grid container spacing={8}>
        <DiligenceRangeFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default DiligenceRangeEdit
